import { combineReducerWithScope, WithPartnerState } from "@gamedev-web/gamedev-sdk-core";

import { PartnerId } from "../../constants";
import { capabilitiesReducer } from "./capabilitiesReducer";
import { partnerCenterReducer } from "./partnerCenterReducer";
import { programsReducer } from "./programsReducer";
import { statusReducer } from "./statusReducer";

export const partnerReducer = combineReducerWithScope({
  capabilities: capabilitiesReducer,
  programs: programsReducer,
  partnerCenter: partnerCenterReducer,
  status: statusReducer,
});

export type OnboardingPartnerState = ReturnType<typeof partnerReducer.reducer>;
export type OnboardingRootState = WithPartnerState<typeof PartnerId, OnboardingPartnerState>;
